import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core";
import { useEffect, useState } from "react";
import NoDataScreen from "../../utilities/NoDataScreenSmall";

import { HeadLines } from "../Dashboard/Dashboard";
import "./Reports.scss";

const MachineStatusFeed = (props: any) => {

    const { title, listData } = props;
    const [active, setActive] = useState(0);
    const [idle, setIdle] = useState(0);
    const [maintenance, setMaintenance] = useState(0);

    useEffect(() => {
        const totalActive = listData.filter((item: any) => { return item?.status?.toUpperCase() === 'ACTIVE' }).length;
        const totalIdle = listData.filter((item: any) => { return item?.status?.toUpperCase() === 'IDLE' }).length;
        const totalMaintenance = listData.filter((item: any) => { return item?.status?.toUpperCase() === 'MAINTENANCE' }).length;

        setActive(totalActive);
        setIdle(totalIdle);
        setMaintenance(totalMaintenance);

    }, [listData])


    return (
        <Grid>

            {listData.length > 0 ? (
                <>
                    <Grid className="flex_start mt1" item xs={12}>
                        <HeadLines
                            label="Active"
                            icon={"approved"}
                            value={active}
                            fontSize={18}
                        />
                        <HeadLines
                            label="Idle"
                            icon={"pending"}
                            value={idle}
                            fontSize={18}
                        />
                        <HeadLines
                            label="Under Maintenance"
                            icon={"rejectionIcon"}
                            value={maintenance}
                            fontSize={18}
                        />
                    </Grid>

                    <TableContainer className="machine_status_table">
                        <Grid>
                            <Table
                                className={`w100`}
                                aria-label="simple table"
                            >
                                <TableHead>
                                    <TableRow>
                                        <TableCell
                                            className="f16 fw500"
                                            align="left"
                                        >
                                            Machine Details
                                        </TableCell>
                                        <TableCell
                                            className="f16 fw500"
                                            align="left"
                                        >
                                            Machine Status
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        listData && listData.map((item: any, index: number) => {

                                            let color = 'red';

                                            if (item?.status?.toUpperCase() === 'ACTIVE') {
                                                color = 'green';
                                            } else if (item?.status?.toUpperCase() === 'IDLE') {
                                                color = '#FFA500';
                                            }

                                            return (
                                                <TableRow key={`row${index}`}>
                                                    <TableCell
                                                        title={"MachineID"}
                                                        className={"f14 fw500 truncate"}
                                                        align="left"
                                                    >
                                                        {item?.machineDetail}
                                                    </TableCell>
                                                    <TableCell
                                                        title={"MachineStatus"}
                                                        className={"f14 fw500 truncate"}
                                                        align="left"
                                                    >
                                                        <span style={{ color: color, textTransform: 'capitalize' }}>{item?.status}</span>
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        })
                                    }
                                </TableBody>
                            </Table>
                        </Grid>
                    </TableContainer>
                </>
            ) : (
                <Grid style={{ height: '18rem', paddingLeft: '1rem' }}>
                    <NoDataScreen text={`There are no data available for ${title}.`} />
                </Grid>

            )
            }
        </Grid >
    )
}

export default MachineStatusFeed;